import {GameStateEnums} from '../../../../../shared/GameEnums'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {UIGameMechanic} from '../UIGameEventController'
import {UIGameManager} from '../UIGameManager'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {InGameAchievement} from '../ui_game_achievement/UIGameAchievementController'
import {TranslationObject} from '@colonist/i18n'
import {MechanicValidatorCityImprovements} from '@colonist/game-mechanic-validators'
import {CityImprovementTypes, PlayerColor} from '@colonist/game-states'
import {EnumUtils} from '@colonist/utils'

export class UIGameMetropolisAchievementController implements UIGameMechanic {
    private readonly uiGameManager: UIGameManager
    private readonly cityImprovementsValidator: MechanicValidatorCityImprovements

    private metropolisOwners: Map<CityImprovementTypes, PlayerColor>

    constructor(uiGameManager: UIGameManager, cityImprovementsValidator: MechanicValidatorCityImprovements) {
        this.uiGameManager = uiGameManager
        this.cityImprovementsValidator = cityImprovementsValidator
        this.uiGameManager.eventController.registerUIGameMechanic(this)
        this.initMetropolisOwners()
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.CityImprovementStateUpdated: this.playerReceivedMetropolis(); break
            default: break
        }
    }

    private playerReceivedMetropolis() {
        const metropolisType = this.getUpdatedMetropolisType()
        if(metropolisType == undefined) return

        const enumKey = EnumUtils.getEnumKey(metropolisType, CityImprovementTypes)
        const title: TranslationObject = {key: `strings:game.achievements.title.metropolis.${enumKey}`}
        const playerColor = this.uiGameManager.gameController.currentState.currentTurnPlayerColor
        const metropolisCornerType = MechanicValidatorCityImprovements.convertCityImprovementTypeToMetropolisType(metropolisType)
        const cityTexture = UIGameSpriteHandler.getCityForPlayer(playerColor)
        const metropolisTexture = UIGameSpriteHandler.getMetropolisForCornerBonusType(metropolisCornerType)

        const achievement: InGameAchievement = {
            title: title,
            achievementOwnerNew: this.uiGameManager.gameController.currentState.currentTurnPlayerColor,
            achievementOwnerPrevious: this.metropolisOwners.get(metropolisType) ?? PlayerColor.None,
            victoryPointChange: 2,
            achievementDurationInSeconds: 5,
            bottomDescription: {key: 'strings:game.achievements.bottomDescription.2VPs'},
            iconTexture: cityTexture,
            iconTextureSecondLayer: metropolisTexture,
        }

        this.metropolisOwners.set(metropolisType, achievement.achievementOwnerNew)
        this.uiGameManager.eventController.sendEvent(achievement, UIGameEventEnums.PlayerReceivedAchievement)
    }

    private initMetropolisOwners() {
        this.metropolisOwners = new Map<CityImprovementTypes, PlayerColor>()
        EnumUtils.iterateEnum(CityImprovementTypes, (cityImprovementType: CityImprovementTypes) => {
            this.metropolisOwners.set(cityImprovementType, this.cityImprovementsValidator.getPlayerColorOfMetropolisOwner(cityImprovementType) ?? PlayerColor.None)
        })
    }

    private getUpdatedMetropolisType(): CityImprovementTypes | undefined {
        let updatedCityImprovementType: CityImprovementTypes | undefined
        EnumUtils.iterateEnum(CityImprovementTypes, (cityImprovementType: CityImprovementTypes) => {
            for(const player of this.uiGameManager.gameController.getPlayerColors()) {
                const playerDidntHaveMetropolisBefore = this.metropolisOwners.get(cityImprovementType) != player
                const playerHasMetropolis = this.cityImprovementsValidator.getPlayerCityImprovementsStateForType(player, cityImprovementType).hasMetropolis
                if(playerHasMetropolis && playerDidntHaveMetropolisBefore) updatedCityImprovementType = cityImprovementType
            }
        })
        return updatedCityImprovementType
    }
}
